/**
 * TCR-2628 (Đơn giao vận) + TCR-2629 (Đơn hàng) — bộ lọc "Miền giao hàng".
 *
 * Một hằng số cho HAI màn: nếu mỗi màn tự liệt kê nhãn riêng thì một ngày nào đó
 * hai màn lệch nhãn và người vận hành phải đoán "Miền Bắc" của màn này có phải
 * "Miền Bắc" của màn kia không.
 *
 * KHÔNG dùng `VN_REGION_LABELS` của `@tcr-erp/shared`: màn ECom đang dùng nhãn đó
 * ("Miền Bắc" / "Miền Trung" / "Miền Nam") và đổi sẽ kéo theo màn khác. Ở đây nhãn
 * ghi rõ thành phố trọng điểm (HN / HCM) để người vận hành định vị nhanh.
 */
import type { VnRegion } from '@tcr-erp/shared';

/** Giá trị gửi lên API (`delivery_region`) — dùng lại kiểu của shared, không chép lại. */
export type DeliveryRegionValue = VnRegion;

export const DELIVERY_REGION_VALUES: readonly DeliveryRegionValue[] = [
  'north',
  'central',
  'south',
] as const;

/** Option cho ô chọn — dùng chung cho Đơn giao vận và Đơn hàng. */
export const DELIVERY_REGION_OPTIONS: readonly {
  label: string;
  value: DeliveryRegionValue;
}[] = [
  { label: 'Miền Bắc (HN)', value: 'north' },
  { label: 'Miền Trung', value: 'central' },
  { label: 'Miền Nam (HCM)', value: 'south' },
] as const;

/**
 * Chốt giá trị rác trên URL (người dùng sửa tay, link cũ) → `undefined`, KHÔNG gửi
 * lên BE: BE chỉ nhận `north` | `central` | `south`, gửi chuỗi lạ sẽ ra bảng lệch
 * mà không có lỗi nào hiện ra.
 */
export function isDeliveryRegionValue(value: string | undefined): value is DeliveryRegionValue {
  return !!value && (DELIVERY_REGION_VALUES as readonly string[]).includes(value);
}

/** Nhãn hiển thị theo giá trị; rác thì trả về chính giá trị để không mất thông tin. */
export function deliveryRegionLabel(value: string | undefined): string {
  if (!value) return '';
  return DELIVERY_REGION_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
